<template>
<div>
    <RichResponseHeadline>Stationsauswahl {{calendarMonth.format()}}</RichResponseHeadline>
    <RichResponseListItem
        v-for="jobsite in jobsites"
        iconType="image"
        :icon="getImageForJobsite(jobsite)"
        :title="jobsite.abbreviation?.toString()"
        :text="jobsite.client?.abbreviation?.toString()"
        @click="jobsiteDetailModalData = jobsite.id"
        :button="true"
    />

    <JobsiteDetails v-model="jobsiteDetailModalData"></JobsiteDetails>
</div>
</template>

<script setup lang="ts">
import RichResponseListItem from "./components/RichResponseListItem.vue"
import {getImageForJobsite} from '@/helper/jobsite'
import {computed, Ref, ref} from "vue";
import {AutopilotJobsite, AutopilotStatus, Jobsite} from "@/graphql/generated/graphql";
import {RichResponseEmits} from './RichResponseComposable'
import {kapitelDateString} from "@/graphql/kapitelTypes";
import {fetchAutopilotStatus} from "@/helper/autopilotStatus";
import {generateCalendarMonth} from "@/helper/calendar/calendarMonth";
import {useEmployeeStore} from "@/store/employee";
import JobsiteDetails from "@/views/JobsiteDetails.vue";
import RichResponseHeadline from "@/views/Chat/RichResponses/components/RichResponseHeadline.vue";

const props = defineProps<{
    initData: kapitelDateString
}>()

const emit = defineEmits(Object.values(RichResponseEmits))

const jobsiteDetailModalData : Ref<number|undefined>= ref(undefined)

const calendarMonth = computed(() => generateCalendarMonth(props.initData))

const jobsites = ref<Jobsite[]>([])


const fetchJobsites = () => {
    const employeeStore = useEmployeeStore()
    return fetchAutopilotStatus(
        calendarMonth.value,
        employeeStore?.storedEmployee
    ).then(
        (res: AutopilotStatus) =>
        {
            jobsites.value = res.autopilotPreferences.autopilotJobsites.map((aj:AutopilotJobsite) => aj.jobsite)
        }
    )
}

fetchJobsites()
</script>
